import type { TProfile } from "@entities/user";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type ProfileState = {
  profile: TProfile | null;
};

type ProfileActions = {
  setProfile: (user: TProfile | null) => void;
  reset: () => void;
};

type ProfileStore = ProfileState & ProfileActions;

const defaultState: ProfileState = {
  profile: null,
};

export const useProfileStore = create<ProfileStore>()(
  persist(
    (set) => ({
      ...defaultState,
      setProfile: (profile) => set({ profile }),
      reset: () => set(defaultState),
    }),
    {
      name: "profile-store",
    }
  )
);
